/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { AxiosRequestConfig } from "axios";

import apiClient from "../../../../services/api-client";

import { DrawdownConfig, SubmitDrawdownPayload } from "./types";

const getDrawdownConfig = (id: string, accountNumber: string) => {
  const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/sales-agreements/${id}/drawdown-config?accountNumber=${accountNumber}`;
  return apiClient.get<DrawdownConfig, AxiosRequestConfig>(apiUrl, { timeout: 60000 });
};

export enum ErrorCode {
  InvalidAgreement = "urn:errors:invalid-agreement",
  InvalidAgreementLine = "urn:errors:invalid-agreement-line",
  InvalidAgreementQuantity = "urn:errors:invalid-agreement-quantity",
  InvalidAgreementSchedule = "urn:errors:invalid-agreement-schedule",
  ValidationError = "urn:errors:validation-error",
}
const submitDrawdown = (data: SubmitDrawdownPayload, recordId: string) => {
  const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/sales-agreements/${recordId}/drawdown`;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return apiClient.post<any, SubmitDrawdownPayload>(apiUrl, data, { timeout: 60000 });
};
export { getDrawdownConfig, submitDrawdown };
